var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('l-control',{attrs:{"position":"topright"}},[_c('b-button',{staticClass:"mb-2",attrs:{"variant":"outline-info"},on:{"click":_vm.clickHandler}},[_c('b-icon',{attrs:{"icon":"geo-alt","aria-label":"Help"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }